import * as Yup from 'yup'
import React from 'react'
import { Formik, FormikProps } from 'formik'
import { createSearchParams, useNavigate } from 'react-router-dom'

import { useParamsToObj } from '../../hooks/useParamsToObj'
import { Place } from '../../types/utils'

import Drawer from '../Drawer'
import UserFiltersForm from './UserFiltersForm'
import Spinner from '../Spinner'

type UserDrawerProps = {
  onClose: () => void
  open: boolean
}

export type FilterData = {
  roles: string[]
  locations: Place[]
}

const schema = Yup.object().shape({
  roles: Yup.array().of(Yup.string()),
  locations: Yup.array().of(Yup.object()),
})

const UserFilterDrawer: React.FC<UserDrawerProps> = ({ onClose, open }) => {
  const navigate = useNavigate()
  const urlParams = useParamsToObj(['search', 'roles', 'locations'])

  const initialValues: FilterData = {
    roles: urlParams.roles || [],
    locations: urlParams.customer || [],
  }

  const handleOnSubmit = async (values: FilterData) => {
    try {
      const searchParams = createSearchParams()

      if (urlParams.search) searchParams.append('search', urlParams.search)

      if (values.locations.length > 0) {
        searchParams.append('locations', JSON.stringify(values.locations.map(({ id, name }) => ({ id, name }))))
      }

      console.log(values)
      if (values.roles.length > 0) {
        searchParams.append('roles', JSON.stringify(values.roles))
      }

      navigate({
        search: `?${searchParams}`,
      })

      onClose()
    } catch (e: any) {
      console.log('🚀 ~ file: UserFilterDrawer.tsx ~ line 52 ~ handleOnSubmit ~ error', e)
    }
  }

  return (
    <Drawer open={open} onClose={onClose}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={schema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={handleOnSubmit}
      >
        {({ isSubmitting, dirty, setFieldValue, values }: FormikProps<FilterData>) => (
          <Drawer.FormContainer
            open={open}
            onClose={onClose}
            title="Filters"
            Footer={
              <>
                <button
                  className="btn btn-white"
                  onClick={() => {
                    navigate({
                      search: ``,
                    })
                    onClose()
                  }}
                  disabled={isSubmitting}
                  type="button"
                >
                  Reset
                </button>

                <button className="btn btn-primary ml-4" type="submit" disabled={isSubmitting || !dirty}>
                  {isSubmitting ? (
                    <>
                      <Spinner className="h-5 w-5 text-gray-700" aria-hidden="true" />
                      Loading
                    </>
                  ) : (
                    'Apply'
                  )}
                </button>
              </>
            }
          >
            <UserFiltersForm isSubmitting={isSubmitting} setFieldValue={setFieldValue} values={values} />
          </Drawer.FormContainer>
        )}
      </Formik>
    </Drawer>
  )
}

export default UserFilterDrawer
